import { useUser } from '@auth0/nextjs-auth0/client';
import { Card, Col, Form, Modal, Row } from 'antd';
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import _, { isEmpty } from 'lodash';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TurnstileWidget from 'src/components/cloudflare/turnstile-widget';
import Layout from 'src/components/layouts';
import SectionIndex from 'src/components/section/section-index';
import ConfirmButton from 'src/components/widget/confirm-button';
import WidgetSuggest from 'src/components/widget/widget-suggest';
import WidgetVoter from 'src/components/widget/widget-voter';
import { APP_IMG, GTM_ID, IMAGE_DEFAULT, IS_NO_ROBOT_INDEX, IS_SHOW_CODE, NEXT_PUBLIC_CF_SITE_KEY, SECRET_KEY_DATA, SUPER_SECRET_KEY, WEB_DESC, WEB_KEYWORD, WEB_NAME, WEB_TITLE, WEB_URL } from 'src/constants';
import { KEY_ACTION } from 'src/stores/reducers/data';
import DynamicAds, { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { DATALAYER_TYPE, sendDataLayer, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets, convertObjPath, timestamp } from 'src/utils/helper';
import { modifiedData, modifiedMergeData } from 'src/utils/modified';
import { redisDB15 } from 'src/utils/redis';
import { GET, GET_REDIS } from 'src/utils/services';
import styled from 'styled-components';

const CountDownButton = dynamic(import('src/components/widget/button-vote-countdown'));
const CategoriesIndex = ({
  categories = [],
  items = [], 
  ads = [],
  refs,
  dataSet,
  ga,
  isCountdown,
  hideFooter,
  remainingTime,
  title,
  dataAll,
  background,
  dataSetRemark,
  showAds
}) => {
  const countdown = !_.isEmpty(dataSet?.dataSet) ? convertDatasets(dataSet?.dataSet, 'เวลานับถอยหลัง', true) : '';
  const successContent = !_.isEmpty(dataSet?.dataSet) ? convertDatasets(dataSet?.dataSet, 'ข้อความหลังโหวตสำเร็จ', true) : '';
  const backgroundCardVote = _.find(dataSet?.dataSet, (el) => el?.key === 'background-card-vote')?.value;
  const meta = !_.isEmpty(dataSet?.dataSet)
    ? {
      title: convertDatasets(dataSet?.dataSet, 'title', true),
      description: convertDatasets(dataSet?.dataSet, 'description', true),
      keywords: convertDatasets(dataSet?.dataSet, 'keywords', true),
      image: convertDatasets(dataSet?.dataSet, 'image', true)
    }
    : {};

  const { user } = useUser(); // ดึงข้อมูลผู้ใช้จาก Auth0

  const router = useRouter();
  const dispatch = useDispatch();
  const [dataResult, setResult] = useState([]);
  const recaptchaRef = useRef(null);
  const confirmButtonRef = useRef(null);
  const [recaptchaBox, setRecaptchaBox] = useState(false);
  const [dataPayload, setDataPayload] = useState(null);
  const [voterCode, setVoterCode] = useState(null);
  const [score, setScore] = useState(null);
  const [validateCheck, setValidateCheck] = useState(false);
  const [form] = Form.useForm();
  const [voteValue, setVoteValue] = useState(null);
  const dataSet2 = _.find(dataAll, { topic: 'section-vote-2' });
  const headerVote = convertDatasets(dataSet2?.dataSet, 'header-vote', true);
  const buttonInfo = convertDatasets(dataSet2?.dataSet, 'button-info', true);
  const backgroundFooter = convertDatasets(dataSet2?.dataSet, 'background-footer', true);
  const linkInfo = convertDatasets(dataSet2?.dataSet, 'link-info', true);
  const video = convertDatasets(dataSet2?.dataSet, 'video', true);
  const selector = useSelector((state) =>
    state.data ? state.data[KEY_ACTION?.SELECT_DATA] : []
  );
  const [useCode, setUseCode] = useState(false);

  const [isError, setIsError] = useState(false);
  const _expires = Cookies.get('vote_exp');

 useEffect(() => {
  const intervalId = setInterval(() => {
    const now = new Date().getMinutes();
    if (now > _expires) {
      window.location.reload();
    }
  }, 60000); // 1 นาที

  // console.log('intervalId',intervalId, {isProd});
  
  // Cleanup function
  return () => clearInterval(intervalId);
  }, [_expires]); 

  const setCookie = (name, value, minutes) => {
    
    Cookies.set(name, value, {
      expires: minutes / 1440,
      sameSite: 'Lax', // None ต้องใช้กับ HTTPS
      secure: true, // true เฉพาะ HTTPS
      path: '/', // เข้าถึงได้ทั้งเว็บ
    });
  };

  function setExpires({ minutes = 10 }) {
    const date = new Date();
    const expires = date.getTime() + (minutes * 60 * 1000);
    // console.log({ 
    //     date: date.toLocaleString('th-TH'), // แสดงเวลาไทยให้เห็น
    //     expires,
    //     expiresDate: new Date(expires).toLocaleString('th-TH')
    // });
    setCookie('vote_exp', expires, minutes);
    setCookie('exp_time', expires, minutes);
  }
  function convertValue(v) {
    if (v) {
      return `${CryptoJS.AES.encrypt(v.toString(), SECRET_KEY_DATA).toString().substring(0, 25)}${v}${CryptoJS.AES.encrypt(v.toString(), SECRET_KEY_DATA).toString().substring(0, 10)}`;
    }
  }

  const onFinish = async (values) => {
    try {
      // console.log('onFinish', { user, values });
      sendDataLayerGlobal({
        type: DATALAYER_TYPE.TRACK_POSITION,
        router: router.pathname,
        section: 'SectionVote',
        position: 'ใน:ฟอร์มข้อมูลโหวต',
        data: {
          heading: 'Confirm Button',
          title: values.voter.voter_email
        }
      });
      const payload = {
        gid: Cookies.get('_ga'),
        selector,
        value: convertValue(voteValue),
        voter: {
          voter_code: !_.isEmpty(values?.voter?.voter_code)
            ? values?.voter?.voter_code?.trim()
            : '',
          voter_gender: values.voter.voter_gender ?? '',
          voter_email: values.voter.voter_email ?? '',
          voter_firstname: values?.voter?.voter_firstname?.trim() ?? '',
          voter_lastname: values?.voter?.voter_lastname?.trim() ?? '',
          voter_phone: values.voter.voter_phone,
          voter_age: values.voter.voter_age
        }

      };
      // console.log('selector', selector);

      if (selector.length > 0) {
        if (Cookies.get('vote_exp')?.trim().length === 0) {
          // กรณี cookies หมดอายุ
          setDataPayload(payload);
          setRecaptchaBox(true);
        }
        // console.log('onFinish payload', payload);
        setDataPayload(payload);
        setRecaptchaBox(true);
      } else {
        Modal.error({
          title: 'ไม่สามารถบันทึกได้',
          content: 'กรุณาเลือกอย่างน้อย 1 รายการ'
        });
      }
    } catch (error) {
      // console.log('onFinish', error);
    } finally {
      setIsError(false);
      setUseCode(false);
      setValidateCheck(false);
      setVoterCode(null);
    }
  };

  function convertSendDataLayer(dataPayload, dataCategories) {
    const cloneCategories = [...dataCategories];
    const dataSelector = dataPayload?.selector;

    for (let num = 0; num < cloneCategories?.length; num++) {
      const keysText = 'event_group_' + num;
      cloneCategories[num].key = keysText;

      for (let j = 0; j < dataSelector?.length; j++) {
        if (cloneCategories[num].key.indexOf(dataSelector[j]?.category_id) > -1) {
          cloneCategories[num].value = cloneCategories[num]?.value?.split('.')[1]?.trim().concat(
            ',',
            dataSelector[j]?.item_name
          );
        }
      }
      if (!cloneCategories[num]?.value?.includes(',')) {
        cloneCategories[num].value = '';
      }
    }

    const result = cloneCategories.reduce((acc, curr) => {
      acc[curr.key] = curr.value;
      return acc;
    }, {});

    return result;
  }

  const onSubmit = async (el) => {
    // console.log('onSubmit', el);
    if (!el) return null;
    try {
      // console.log('onSubmit', el, dataPayload);
      const _payloadData = {
        ...dataPayload,
        userData: el,
        ref: refs
      };
      setRecaptchaBox(true);

      // console.log('_payloadData', _payloadData, ga);


      const _payload = CryptoJS.AES.encrypt(
        JSON.stringify(_payloadData),
        SECRET_KEY_DATA
      ).toString();
      const response = await fetch('/api/votes/votes-items', {
        method: 'POST',
        body: JSON.stringify({ data: _payload, validateCheck: validateCheck }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      // console.log('response', response);
      if (response.ok) {
        // console.log('countdown', countdown);
        // ตั้งเวลาในการโหวต 10 นาที สามารถเปลี่ยนได้จาก dataSet
        setExpires({ minutes: countdown });

        // ---------------------
        const listCategories = convertSendDataLayer(dataPayload, categories);
        const listData = {
          event: 'track_event_awards',
          event_category: `homepage:${`การร่วมโหวต : ${successContent}`}`,
          event_action: `${dataPayload?.voter?.voter_email}`,
          event_label: `${dataPayload?.voter?.voter_gender}:${dataPayload?.voter?.voter_age}`,
          event_name: dataPayload?.voter?.voter_firstname && dataPayload?.voter?.voter_lastname ? `${dataPayload?.voter?.voter_firstname} ${dataPayload?.voter?.voter_lastname}` : null,
          event_phone: dataPayload?.voter?.voter_phone ? `${dataPayload?.voter?.voter_phone}` : null,
          event_time: `${timestamp()}`
        };
        const dataLayer = { ...listData, ...listCategories };

        sendDataLayer(dataLayer);

        Modal.success({
          title: 'ขอบคุณสำหรับคะแนนโหวต',
        
          content: (
            <>
              <div> {successContent ?? ''} </div>
              {/* {showAds &&
                    <DynamicAds
                      type={KEY_ADS_POSITION.INARTICLE_1}
                      section='home'
                      adsName='logo-Awards'
                      />
              } */}
            </>
          ),
          // โหวตสำเร็จ ปิด popup แล้วรีโหลดหน้าใหม่ และกลับไปด้านบนสุด
          afterClose: () => {
            // ปิดการจำตำแหน่ง scroll ของ browser ไม่ให้เด้งกลับมาที่ปุ่มโหวตหลังรีโหลด
            window.history.scrollRestoration = 'manual';
            window.scrollTo(0, 0);
            window.location.reload();
          }
        });
      } else responseError(response);
    } catch (err) {
      console.error('onSubmit error: ', err);
      Modal.error({
        title: 'บันทึกข้อมูลไม่สำเร็จ',
        content: 'กรุณาทำรายการใหม่อีกครั้งภายหลัง'
      });
    } finally {
      recaptchaRef.current = null;
      setRecaptchaBox(false);
    }
  };

  const statusToTitleMap = {
    400: 'โค้ดนี้ถูกใช้งานไปแล้ว',
    401: 'รหัสโค้ดไม่ถูกต้อง หรือ โค้ดนี้ถูกใช้งานไปแล้ว',
    402: 'กรุณากดใช้งาน code ก่อน Vote',
    default: 'บันทึกข้อมูลไม่สำเร็จ'
  };

  function responseError(response) {
    // console.log('responseError', response);
    const content = 'กรุณาทำรายการใหม่อีกครั้งภายหลัง';
    const title = statusToTitleMap[status] || statusToTitleMap.default;

    Modal.error({
      title,
      content
    });
  }

  function handleSelection({ selected }) {
    const payload = {
      category_id: selected.category_id,
      category_name: selected.category_name,
      item_id: selected.item_id,
      item_name: selected.item_name,
      item_image: selected.item_image,
      code_type: ''
    };

    setResult(prevDataResult => {
      let newDataResult;
      const duplicateIndex = prevDataResult.findIndex(e => e.item_id === selected.item_id);

      if (duplicateIndex !== -1) {
        newDataResult = prevDataResult.filter((_, index) => index !== duplicateIndex);
      } else {
        if (prevDataResult.length > 0) {
          newDataResult = prevDataResult.slice(0, prevDataResult.length - 1);
        } else {
          newDataResult = [...prevDataResult];
        }
        newDataResult.push(payload);
      }

      dispatch({ type: KEY_ACTION.SELECT_DATA, result: newDataResult });
      return newDataResult;
    });
  }

  function checkSelect({ _cid }) {
    return dataResult.some(e => e.item_id === _cid);
  }

  const layout = {
    labelCol: { xs: { span: 24 } },
    wrapperCol: { xs: { span: 24 } }
  };

  const _background = {
    title: convertDatasets(background?.dataSet, 'title', true),
    description: convertDatasets(background?.dataSet, 'description', true),
    keywords: convertDatasets(background?.dataSet, 'keywords', true),
    image: convertDatasets(background?.dataSet, 'image', true),
    desktop: _.find(background?.dataSet, (el) => el?.key === 'background-desktop')?.value,
    mobile: _.find(background?.dataSet, (el) => el?.key === 'background-mobile')?.value
  };



  useEffect(() => {
    if (user?.email) {
      form.setFieldsValue({
        voter: {
          voter_email: user.email
        }
      });
    }
  }, [user?.email, form]);

  useEffect(() => {
    if (dataResult.length > 0) {
      confirmButtonRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [dataResult]);

  // console.log('items',items)
  return (
    <>
      <NextSeo
        noindex={IS_NO_ROBOT_INDEX}
        nofollow={IS_NO_ROBOT_INDEX}
        title={_background?.title || WEB_TITLE}
        description={_background?.description || WEB_DESC}
        openGraph={{
          type: 'article',
          locale: 'th_TH',
          url: `${WEB_URL.WEB}/vote`,
          title: _background?.title || WEB_TITLE,
          description: _background?.description || WEB_DESC,
          images: [
            {
              url: _background?.image || IMAGE_DEFAULT,
              width: '1920',
              height: '1080',
              alt: WEB_NAME
            }
          ]
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: _background?.keywords || WEB_KEYWORD
          }
        ]}
      />
      <Head>
        <link rel='canonical' href={`${WEB_URL.WEB}/vote`} />
        <meta property='twitter:title' content={_background?.title || WEB_TITLE} />
        <meta property='twitter:description' content={_background?.description || WEB_DESC} />
        <meta property='twitter:image' content={_background?.image || IMAGE_DEFAULT} />

        {/* ----------------------------- Google Analytic ---------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({
            'gtm.start':new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');`
          }}
        />
        {/* ---------------------------- SPIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                  {
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    "name": "${WEB_NAME}",
                    "url": "${WEB_URL.WEB}/vote",
                    "description": "${_background?.description || WEB_DESC}",
                    "sameAs": [
                      "${WEB_URL.FACEBOOK}",
                      "${WEB_URL.X}",
                      "${WEB_URL.INSTAGRAM}",
                      "${WEB_URL.YOUTUBE}",
                      "${WEB_URL.LINE}"
                    ],
                    "potentialAction": {
                      "@type": "SearchAction",
                      "target": "${WEB_URL.WEB}search?q={search_term_string}",
                      "query-input": "required name=search_term_string"
                    }
                  }
                }
              `
          }}
        />
        {/* ---------------------------- SPIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                  {
                    "@context": "http://schema.org",
                    "@type": "WebPage",
                    "name": "${WEB_NAME}",
                    "description": "${_background?.description || WEB_DESC}",
                    "publisher": {
                      "@type": "ProfilePage",
                      "name": "${WEB_NAME}"
                    }
                  }
                `
          }}
        />
      </Head>
      <Layout dataset={dataAll} data={background} hideFooter={hideFooter}>
        <h1>{meta?.title || WEB_TITLE}</h1>
        <h2>{meta?.description || WEB_DESC}</h2>
        <PageWrapper bgDesktop={_background?.desktop} bgMobile={_background?.mobile || _background?.desktop}>
        <a href='/'>
          <SectionIndex data={_.find(dataAll, { topic: 'section-vote-1' })} showAds={false} />
        </a>
        <BgWrapper bgImage={convertDatasets(dataSet2?.dataSet, 'background-image', true)}>
          {video ||linkInfo &&  <Container>
            {video && <div className='video-info' dangerouslySetInnerHTML={{ __html: `${video}` }} />}
            {linkInfo
              ? <a href={linkInfo} target='_blank'><img className='header-info' width={'100%'} height={'100%'} src={buttonInfo} /></a>
              : buttonInfo && <img className='header-info' width={'100%'} height={'100%'} src={buttonInfo} />
            }
          </Container>}

          {(!_.isEmpty(ads) && showAds) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}
          <SectionWrapper disable={_expires}>
            {headerVote && <img className='header-vote' width={'100%'} height={'100%'} src={headerVote} />}

            <Form
              form={form}
              name='form'
              layout='vertical'
              onFinish={onFinish}
              scrollToFirstError={true}
              onClick={() => {
                // console.log('Form Click', user);
                if (isEmpty(user)) {
                  window.location.href = `/api/auth/login?returnTo=${router.asPath}`
                }
              }}
              onValuesChange={(e) => {
                if (e?.voter?.voter_code) {
                  const voterCode = e.voter.voter_code?.trim();
                  if (voterCode === '') {
                    setIsError(false);
                    setUseCode(false);
                    setValidateCheck(false);
                    setVoterCode(null);
                  }
                  setVoterCode(voterCode);
                }
              }}
              {...layout}
            >
              {!!_expires && <CountDownButton   />}
              <Row className='user-wrapper'>
                <Col xs={24}>
                  {(_.isEmpty(_expires)) &&
                    <>
                      <WidgetVoter
                        labelCode={'คูปองพิเศษ'}
                        disabled={_expires}
                        onClick={async () => {
                          try {
                            setUseCode(true);
                            const response = await fetch('/api/votes/check-code', {
                              method: 'POST',
                              body: JSON.stringify({ data: voterCode?.trim() }),
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              timeout: 5000 // Timeout after 5 seconds
                            }).then((res) => res.json())
                              .then((data) => data);

                            if (response.status === 200) {
                              // console.log('response', response.score);
                              setScore(response.score);
                              setIsError(false);

                              setValidateCheck(true);
                              setVoterCode(voterCode);
                            } else {
                              // console.log('error', response);
                              setIsError(true);
                              setScore(null);
                            }
                          } catch (error) {
                            // console.log('error', error);
                          }
                        }}
                        score={score ?? null}
                        useCode={useCode}
                        showButton={!_.isEmpty(voterCode) && score === null}
                        isError={isError || score === null}
                        voterCod={voterCode}
                        help={(useCode && score != null ? `คะแนนพิเศษ ${score} คะแนน` : (isError) && 'รหัสโค้ดไม่ถูกต้อง หรือ โค้ดนี้ถูกใช้งานไปแล้ว')}
                        showCode={IS_SHOW_CODE === 'show'}
                      />
                    </>
                  }

                </Col>
              </Row>

              <Container className='container-vote'>
                <CardLists className='card-lists' bgCardVote={backgroundCardVote}>
                  {_.map(items, (item, index) => (
                    <Card className={`card-vote ${(index === items?.length - 1) && (index % 2 === 0) ? 'to-left' : ''} ${checkSelect({ _cid: item.item_id }) ? 'is-selected' : (!_.isEmpty(dataResult) ? 'is-dimmed' : '')}`} key={index} onClick={() => !_expires && handleSelection({ selected: item })} aria-label={item.item_name}  >
                      <div className={`image-wrapper ${checkSelect({ _cid: item.item_id }) ? 'selected' : ''}`}>
                        <img
                          className='custom-image'
                          alt={item.item_name}
                          src={item.item_image
                            ? `${item.item_image}?x-image-process=style/MD`
                            : `${APP_IMG}/award/default-awards.jpg`} />
                        {/* {IS_SHOW_NAME && <div className='name'>
                          {`${index + 1}. ${item.item_name}`}
                        </div>} */}
                      </div>
                    </Card>
                  ))}
                </CardLists>
                {(showAds && !_.isEmpty(ads)) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />}

                <Row className='user-wrapper'>
                  <Col xs={24} className='ant-col'>
                    {isCountdown
                      ? <CountDownButton remainingTime={remainingTime} />
                      : <div>
                        {(recaptchaBox)
                          ?
                          <VoteWrapper>
                            <TurnstileWidget siteKey={NEXT_PUBLIC_CF_SITE_KEY} onVerify={onSubmit} />
                          </VoteWrapper>
                          : _expires
                            // ? <CountDownButton />
                            ? <></>
                            : <VotePanel>
                              <div className='vote-panel-title'>ยืนยันการโหวต</div>
                              {/* แสดงคนที่เลือกเหนือปุ่มโหวต ให้ผู้โหวตรู้ว่ากำลังโหวตให้ใคร */}
                              <SelectedPreview>
                                {!_.isEmpty(dataResult)
                                  ? <div className='selected-item'>
                                    <div className='avatar'>
                                      <img
                                        className='avatar-image'
                                        alt={dataResult[0]?.item_name}
                                        src={dataResult[0]?.item_image
                                          ? `${dataResult[0].item_image}?x-image-process=style/MD`
                                          : `${APP_IMG}/award/default-awards.jpg`} />
                                    </div>
                                    <div className='label'>คุณกำลังโหวตให้</div>
                                    <div className='name'>{dataResult[0]?.item_name}</div>
                                  </div>
                                  : <div className='hint'>กรุณาเลือกผู้เข้าชิงที่ต้องการโหวต</div>}
                              </SelectedPreview>
                              <VoteWrapper ref={confirmButtonRef}>
                                <ConfirmButton child={'VOTE'} onClick={() => setVoteValue(1)} />
                              </VoteWrapper>
                            </VotePanel>
                        }
                      </div>
                    }
                  </Col>
                </Row>
                               
                {!_.isEmpty(dataSetRemark) && (
                  <WidgetSuggest
                    showAds={false}
                    title={convertDatasets(dataSetRemark?.dataSet, 'title', true) || 'กติกาการโหวต'}
                    data={_.filter(
                      dataSetRemark?.dataSet,
                      (el) => el?.key?.split('-')[0] === 'หมายเหตุ'
                    ) ?? null}
                  />
                )}
              </Container>



            </Form>
            <div className='desc-text'>{convertDatasets(dataSet?.dataSet, 'desc-text', true)}</div>
          </SectionWrapper>
          {(backgroundFooter || (showAds && !_.isEmpty(ads))) && (
            <div
              className='background-footer'
              style={backgroundFooter ? { backgroundImage: `url(${backgroundFooter})` } : undefined}
            >
              {(showAds && !_.isEmpty(ads)) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_2} data={ads} />}
            </div>
          )}
        </BgWrapper>
        </PageWrapper>
      </Layout>
    </>
  );
};

export async function getServerSideProps({ req, res, query }) {
  const initProps = {
    categories: [],
    dataSet: [],
    dataSetRemark: [],
    items: [],
    background: null,
    hideFooter: null,
    hideCover: null,
    ga: null,
    isCountdown: false,
    remainingTime: null,
    title: null,
    location: null,
    showAds: null,
    ads: []
  };
  try {
    if (query.cid === 'vote') {
      const categoriesData = await GET_REDIS('redisDB0');

      const scoreData = await GET_REDIS('redisDB4', true, 'votes:group_0');
      // console.log('scoreData', scoreData);
      const itemsVotesData = await GET_REDIS('redisDB6'); // รวมนักแสดงที่ได้รับการโหวตทุกสาขา
      // console.log('query', query);
      if (!_.isEmpty(query?.hideFooter) || !_.isEmpty(query?.hideCover)) {
        initProps.hideFooter = String(query?.hideFooter) === '1' || null;
        initProps.hideCover = String(query?.hideCover) === '1' || null;
      }

      if (!_.isEmpty(query?.ga)) {
        initProps.ga = query.ga;
      }
      const countdown = await redisDB15.hmget(query?.ga, 'ga', query?.ga);
      if (!_.isEmpty(countdown[0])) {
        initProps.isCountdown = true;
        const remainingTime = await redisDB15.ttl(query?.ga);
        initProps.remainingTime = remainingTime;
      }

      /* --------------------------------- DataSet -------------------------------- */
      const dataSetsAll = await GET(
        `/api/datasets${convertObjPath({ limit: 40 })}`
      );
      if (!_.isEmpty(dataSetsAll)) {
        if (_.isEmpty(_.find(dataSetsAll, { topic: 'section-schedule' }) || [])) {
          return {
            redirect: {
              destination: '/',
              permanent: false
            }
          };
        }
        initProps.dataSet = _.find(dataSetsAll, { topic: 'section-votes' }) || [];
        initProps.dataSetRemark = _.find(dataSetsAll, { topic: 'section-remark' }) || [];
        initProps.dataAll = dataSetsAll;
        initProps.background = _.find(dataSetsAll, { topic: 'background' }) || {};
        initProps.showAds = !_.isEmpty(_.find(dataSetsAll, { topic: 'show-ads' }));
      }
      /* --------------------------------- DataSet -------------------------------- */

      initProps.categories = modifiedData(categoriesData) || [];
      // console.log(itemsVotesData, scoreData );

      const votes = modifiedMergeData(itemsVotesData, modifiedData(scoreData), query?.cid);

      const indexVote = votes.findIndex((el) => el?.group === query?.cid);
      // console.log('votes 4', votes);
      if (indexVote !== -1) {
        initProps.items = votes;
        initProps.title = votes[indexVote]?.category_name;
        if (!_.isEmpty(query?.location)) {
          initProps.location = query?.location;
        }
        /* ---------------------------------- REDIS --------------------------------- */
        const dataSecret = {
          username: '$}25tQg.ctj@7C.2r(j+R.;KNF3ERT',
          password: 'M:]?-@Gnd#/M*ZEM(G%eY5]qfg7p_W'
        };
        initProps.refs = CryptoJS.AES.encrypt(
          JSON.stringify(dataSecret),
          SUPER_SECRET_KEY
        ).toString();
      }

      const adsLists = await GET(`${APP_IMG}/awards/ads-slots-vote.json`, true);
      initProps.ads = !_.isEmpty(adsLists) ? adsLists : null;
    } else {
      return {
        redirect: {
          destination: '/',
          permanent: false
        }
      };
    }
  } catch (error) {
    console.error(`${timestamp()} ==========> PAGE_CATEGORIES ERROR : `, error);
  }

  return {
    props: { ...initProps }
  };
}

const PageWrapper = styled.div`
  width: 100vw;
  background-image: ${props => props.bgDesktop ? `url(${props.bgDesktop})` : 'none'};
  background-size: cover;
  background-position: bottom;
  @media (max-width: 768px) {
    background-image: ${props => props.bgMobile ? `url(${props.bgMobile})` : 'none'};
  }
`;

const BgWrapper = styled.div`
  position: relative;
  width: 100vw;
  background-image: url(${props => props.bgImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  &.footer {
    min-height: 400px;
  }
  .background-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 470px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    @media (max-width: 768px) {
       min-height: 170px;
    }
  }
`;

const VotePanel = styled.div`
  position: relative;
  max-width: 520px;
  margin: 70px auto 0;
  padding: 40px 30px 35px;
  border: 1px solid rgb(242 202 70 / 60%);
  border-radius: 24px;
  background: rgb(6 11 9 / 75%);
  box-shadow: 0 10px 40px rgb(0 0 0 / 45%);
  backdrop-filter: blur(4px);
  /* เส้นคั่นระหว่างส่วนเลือกผู้เข้าชิงกับส่วนโหวต */
  &::before {
    content: '';
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    width: 160px;
    height: 2px;
    background: linear-gradient(90deg, transparent 0%, #f2ca46 50%, transparent 100%);
  }
  .vote-panel-title {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 6px 24px;
    border-radius: 50px;
    background: linear-gradient(90deg, #ab8000 0%, #f2ca46 100%);
    color: #050B09;
    font-size: 16px;
    font-weight: 600;
    white-space: nowrap;
  }
  @media (max-width: 767px) {
    margin: 50px 0px 0px;
    padding: 35px 15px 25px;
    border: 5px solid rgb(242 202 70 / 60%);
    &::before {
      top: -28px;
    }
  }
`;

const SelectedPreview = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  text-align: center;
  color: #fff;
  .selected-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: selected-pop 0.3s ease;
  }
  .avatar {
    position: relative;
    width: 250px;
    height: 250px;
    padding: 4px;
    border-radius: 50%;
    background: linear-gradient(90deg, #ab8000 0%, #f2ca46 100%);
    box-shadow: 0 0 20px 2px rgb(255 231 37 / 50%);
    .avatar-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top center;
      border-radius: 50%;
      border: 3px solid #fff;
    }
  }
  .label {
    margin-top: 12px;
    font-size: 18px;
    opacity: 0.85;
  }
  .name {
    font-size: 24px;
    font-weight: 600;
    color: #f2ca46;
    text-shadow: 2px 2px 4px #000000;
  }
  .hint {
    font-size: 16px;
    opacity: 0.85;
  }
  @media (max-width: 767px) {
    .avatar {
      width: 190px;
      height: 190px;
    }
    .label {
      font-size: 16px;
    }
    .name {
      font-size: 22px;
    }
  }
  @keyframes selected-pop {
    from { transform: scale(0.85); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  }
`;

const VoteWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  z-index: 0;
  position: relative;
  max-width: 600px;
  margin: 0 auto;
  @media (max-width: 768px) {
    max-width: 100px;
  }
`;

const CardLists = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 50px 0;
  padding-bottom: 50px;
  flex-wrap: wrap;
  position: relative;
  gap: 30px;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(4, 20%);
    justify-content: space-between;
    gap: 30px 0;
  }
  @media (width: 768px) {
    grid-template-columns: repeat(4, 22%);
  }
  .number, .name {
    position: absolute;
    padding: 0;
    left: 15px;
    bottom: 10px;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    text-shadow: 2px 2px 4px #000000;
  }
  @media (max-width: 768px) {
    padding: 40px 0;
    gap: 30px 0;
     .number {
      font-size: 24px;
      left: 20%;
      top: 20%; 
    }
  }
  @media (max-width: 690px) {
    padding: 40px 0;
    gap: 30px 0;
     .number {
      font-size: 20px;
      left: 20%;
      top: 20%; 
    }
  }
.to-left {
  margin-right: auto;
}  
.card-vote {
position: relative;
  width: 20%;
  padding: 0;
  border: none;
  background: none;
  background-image: ${props => props.bgCardVote ? `url(${props.bgCardVote})` : 'none'};
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 14px;
  transition: transform 0.3s ease, opacity 0.3s ease, filter 0.3s ease, box-shadow 0.3s ease;
  &.is-selected {
    z-index: 1;
    transform: scale(1.05);
    box-shadow: 0 0 25px 5px rgb(255 231 37 / 80%);
  }
  &.is-dimmed {
    opacity: 0.6;
    filter: grayscale(60%);
    &:hover {
      opacity: 0.9;
      filter: none;
    }
  }
  @media (max-width: 768px) {
     width: 22%;
   }
  @media (max-width: 767px) {
     width: 45%;
   }
  @media (min-width: 768px) {
    width: 100%;
    margin-right: 0;
  }
}
    .ant-card-body {
     
   padding: 0px;
  /* @media (max-width: 768px) {
        padding: 0;
          width: 33%;
    }

  @media (max-width: 375px) {
      padding: 0;
        width: 50%;
    } */
    .ant-card-body {
      position: relative;
      @media (max-width: 767px) {
      padding: 0 10px;
    }
    }
    .logo-select {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 5;
        z-index: 1;
        color: #FFF;
        background: #720101;
        width: 100%;
        height: 100%;
        border-radius: 13px;
        .vote {
          content: '';
          position: absolute;
          left: 0px;
          width: 100%;
          display: block;
          /* height: 80px; */
          height: 100px;
          background-image: url(static/images/vote.svg);
          z-index: -1;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
}

  .custom-title {
    cursor: pointer;
    font-size: 30px;
    font-weight: 600;
    /* padding: 3px; */
    display: flex;
    text-align: center;
    /* border-radius: 18px; */
    color: #fff;
    margin-bottom: 30px;
    @media (max-width: 767px) {
        margin-bottom: 10px;
    }
    span {
      background: #000;
      width: 100%;
      display: block;
      text-align: start;
      border-radius: 18px;
      margin: auto;
      line-height: 1.65;
      padding: 5px 10px;
      font-size: 16px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      -webkit-line-clamp: 2;
      min-height: 62px;

      @media (max-width: 767px) {
        font-size: 16px;
        padding: 5px;
      }
    }
  }

  .image-wrapper {
    position:  relative;
    aspect-ratio: 3/4;
    /* margin-bottom: 15px; */
    img {
      aspect-ratio: 3/4;
    }
    &.selected{
      border-radius: 15px;
      position: relative;
      padding: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
  }
  }
  .wrapper {
    position: relative;
    width: auto;
    cursor: pointer;
    &:hover {
      .inside {
        background-color: #f2ca46FF !important;
        background: #f2ca46FF !important;
      }
    }
    @media (max-width: 475px) {
    padding-top: 5px;
    min-height: 50px;
    }
  .circle {
    margin: auto;
    height: 35px;
    width: 35px;
    background:linear-gradient(90deg, #ab8000 0%,  #f2ca46 100%);
    border-radius: 50px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 475px) {
        height: 20px;
        width: 20px;
      }
    .inside {

      cursor: pointer;
      height: 20px;
      width: 20px;
      background: rgb(166,166,166);
      background: linear-gradient(180deg, rgba(166,166,166,1) 0%, rgba(255,255,255,1) 100%);
      border-radius: 50%;
      @media (max-width: 767px) {
        height: 25px;
        width: 25px;
      }
      @media (max-width: 475px) {
        height: 10px;
        width: 10px;
      }
    }
    .selected {
      background-color: #f2ca46 !important;
      background: #f2ca46 !important;
    }
  }
}
  .ant-image {
    width: 100%;
    border-radius: 50%;
  }
.custom-image {
  cursor: pointer;
  border-radius: 5px 5px 0px 0px;

  border-radius: 15px;
  padding:0px;
  aspect-ratio: 3/4;
  overflow: hidden;
  width: 100%;
  object-fit: cover;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
`;

const Container = styled.div`
  position: relative;
  display: block;
  width: 100%;
  max-width: 1300px;
  margin: auto;
  padding: 0px 15px;
  padding-bottom: 90px;
  min-height: auto;
  &.container-vote {
    padding: 0;
  }
  .video-info {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 30px 0;
    @media (max-width: 475px) {
      iframe {
        width: 100%;
        max-width: 100%;
        height: 200px;
      }
    }
  }
  .header-info {
    display: flex;
    width: 100%;
    max-width: 1000px;
    margin: auto;
  }
  @media (max-width: 475px) {
    min-height: auto;
    padding-bottom: 0px;
    span {
      display: block;
    }
  }
  a {
    text-decoration: none;
  }
  .back-button {
    width: 100%;
    max-width: 160px;
    justify-content: flex-start;
    margin: 0;
    button {
      justify-content: flex-start;
      transition: none;
      &:hover {
    animation: bounceLeft 2s ease infinite;

    @keyframes bounceLeft {
      100% {
        transform: translateX(0);
      }
      50% {
        transform: translateX(-20px);
      }
    }
}
    }

  }
  .ads-logo-awards {
    display: flex;
    justify-content: center;
    height: 250px;
    width: 100%;
    max-width: 100%;
    margin-bottom: 30px;
    @media (max-width: 475px) {
      margin-bottom: 15px;
    }
  }
  .col {
    position: relative;
  }
  .image-header {
    width: 100% !important;
    height: auto !important;
  }
  .ads-billboard {
    position: absolute;
    right: 0;
  }
  .heading {
    color: #fff;
    display: block;
    text-align: center;
    font-size: 32px;
  }
  .background-gradient,
  .carousel-wrapper {
    background: transparent;
  }

.ads-award1,.ads-award2,.ads-award3,.ads-award4 {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    height: 320px;
    /* margin: 30px auto; */
}
.ads-sticky {
    display: flex;
    justify-content: center;
    height: 320px;
}
.ads-inarticle {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    height: 400px;
}
`;
const SectionWrapper = styled.div`
  position: relative;
  display: block;
  z-index: 2;
  /* padding-top: 50px; */
  .ant-form {
  padding: 0 15px;
  }
  .header-vote {
    display: flex;
    width: 100%;
    max-width: 1200px;
    margin: auto;
    @media (max-width: 768px) {
      max-width: 100%;
    }
  }

  .user-wrapper {
    position: relative;

    .count-down {
      z-index: 1;
      position: relative;
      display: block;
      border-radius: 8px;
      padding: 3px;
      background-color: #060b09;
      color: #fff;
  .text-countdown {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #060b09;
    color: #fff;
    border-radius: 3px solid  #060b09;
    padding: 10px;
    font-size: 24px;
    border-radius: 5px;
    p {
      padding-left: 10px;
    }
  }

  @media (max-width: 768px) {
    .text-countdown {
      display: block;
      text-align: center;
      /* font-size: 20px; */
    }
  }
    }
    .ant-col-bb {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      max-width: 100% !important;
      div { 
        width: 100%;
      }
    }
  }
  .desc-text {
    font-size: 30PX;
    line-height: 1.45;
    color: #fff;
    font-weight: 800;
    text-align: center;
    letter-spacing: 1px;
    margin-top: 0px;
    @media (max-width: 767px) {
      font-size: 18px;
    }
    @media (max-width: 475px) {
      font-size: 16px;
    }
  }
  .text-header {
    color: #fff;
    line-height: 1;
    font-weight: 900;
    font-size: 128px;
    text-align: center;
    letter-spacing: 2px;
    margin-bottom: 20px;
    @media (max-width: 767px) {
      font-size: 48px;
    }
  }
  .ads-carousels-desktop .ant-row {
    justify-content: center;
  }

  .ads-inarticle {
    width: 100%;
    margin: auto;
    text-align: center;
  }
`;

export default CategoriesIndex;
